export default function getTicketTitle(menuPath: string, summary: string) {
  switch (menuPath) {
    case "IH\\PR\\PS\\PS\\SR\\SR":
    case "IH\\PR\\PS\\PS\\SR\\FS":
      return undefined; // returning nothing here prevents duplicate headers in the requests
    case "IH\\PR\\PS\\PS\\ST\\QG":
      return "Qmlativ - Custom API Support Request";
    case "IH\\PR\\PS\\PS\\ST\\QR":
      return "Qmlativ - OneRoster Support Request";
    case "IH\\PR\\PS\\PS\\ST\\QO":
      return "Qmlativ - Other Support Request";
    case "IH\\PR\\CM\\SC":
      return "Qmlativ - DMI Support Request";
    case "IH\\PR\\PS\\PS\\ST\\SL":
      return "SMS - LMS Support Request";
    case "IH\\PR\\PS\\PS\\ST\\SR":
      return "SMS - OneRoster Support Request";
    case "IH\\PR\\PS\\PS\\ST\\SO":
      return "SMS - Other Support Request";
    case "IH\\PR\\PS\\PS\\ST\\SS":
      return "SMS - SkyBuild Support Request";
    default:
      return summary;
  }
}
